<section class="return-method-choice">
  <h4 class="fw-bold mb-2">{{ settings().returnPageTitle }}</h4>

  <p class="return-method-choice__description">{{ settings().returnPageDescription }}</p>

  <div class="radio-button-group mt-4">
    @for (option of options(); track option.method) {
      <label class="radio-button return-method-choice__option">
        <input type="radio"
               name="returnMethod"
               [value]="option.method"
               [checked]="selected() === option.method"
               (change)="methodChange.emit(option.method)"/>

        <div>
          <div class="fw-bold font-lg">{{ option.title }}</div>
          <div class="font-sm font-mute mt-1">{{ option.description }}</div>
        </div>
      </label>
    }
  </div>
</section>
